/**
 * Video Testimonials row (Tolstoy replacement).
 * Click a circular avatar -> lazy-clone its <template> video markup into
 * a shared modal (no video bytes are fetched until this point) -> play.
 * Shared between homepage and PDP instances of this component.
 */
(function () {
  function closeModal(modal) {
    var mediaHost = modal.querySelector('[data-vtr-media]');
    var video = mediaHost ? mediaHost.querySelector('video') : null;
    if (video) {
      try { video.pause(); } catch (e) {}
    }
    if (mediaHost) mediaHost.innerHTML = '';
    modal.setAttribute('hidden', '');
    document.body.classList.remove('vtr-modal-open');
  }

  function openModal(modal, templateEl, triggerEl) {
    var mediaHost = modal.querySelector('[data-vtr-media]');
    if (!mediaHost || !templateEl) return;
    mediaHost.innerHTML = '';
    mediaHost.appendChild(templateEl.content.cloneNode(true));
    modal.removeAttribute('hidden');
    document.body.classList.add('vtr-modal-open');

    var video = mediaHost.querySelector('video');
    if (video) {
      video.removeAttribute('preload');
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    var closeBtn = modal.querySelector('[data-vtr-close]');
    if (closeBtn) closeBtn.focus();

    modal._vtrTrigger = triggerEl;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-vtr-trigger]');
    if (trigger) {
      var item = trigger.closest('.vtr__item');
      var templateEl = item ? item.querySelector('template[data-vtr-source]') : null;
      var modal = document.querySelector('[data-vtr-modal]');
      if (modal && templateEl) openModal(modal, templateEl, trigger);
      return;
    }

    var closeTarget = event.target.closest('[data-vtr-close]');
    if (closeTarget) {
      var modalEl = closeTarget.closest('[data-vtr-modal]');
      if (modalEl) closeModal(modalEl);
      return;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openModalEl = document.querySelector('[data-vtr-modal]:not([hidden])');
    if (openModalEl) closeModal(openModalEl);
  });
})();
